var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row container-center"},[_c('div',{staticClass:"col-md-5 col-sm-12 col-lg-5"},[_c('v-text-field',{attrs:{"outlined":"","label":"Escriba su respuesta:","rules":_vm.rules,"hide-details":"auto"},on:{"input":_vm.saveAnswers}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }